import React, { useRef, useEffect } from 'react';
import styles from './About.module.css'

function About() {
    const aboutRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        (window as any).aboutRef = aboutRef;

    }, []);

    return (
        <div ref={aboutRef} className={styles.container}>
            <div className={styles.content}>
                <div className={styles.title}>
                    <div>QUEM SOMOS</div>
                </div>
                <div className={styles.text}>
                    <p>Somos um pequeno grupo de professores e alunos do Bacharelado de em Ciência da Computação do Campus Professor Antônio Giovanni Alves de Sousa da Universidade Estadual do Piauí. O principal objetivo deste projeto é propiciar o uso dos conhecimento adquiridos dentro e fora da sala de aula pelo corpo discente, por meio das atividades de ensino, pesquisa e extensão em engenharia de software e sistemas aplicadas em projetos de software reais, prestando serviços de desenvolvimento de software à comunidade.</p><br />
                    <p>O LES – Laboratório de Engenharia de Software comporta atividades de ensino, pesquisa e extensão, na forma de projetos de desenvolvimento de software a serem executados conforme solicitada a posteriori pela comunidade em geral de acordo com modelo em anexo. Cabe à Coordenação do projeto analisar a solicitação, avaliar sua viabilidade e aprovar sua execução e recrutamento de colaboradores para a execução do projeto. O recrutamento para a execução dos projetos aceitos terá ampla divulgação. A cada projeto concluído enviado à PREX relatório de atividades realizadas no período para a certificação devida.</p>
                </div>
            </div>
        </div>
    )
}

export default About;